import { render, staticRenderFns } from "./RWASection.vue?vue&type=template&id=2b296a70&scoped=true"
import script from "./RWASection.vue?vue&type=script&lang=js"
export * from "./RWASection.vue?vue&type=script&lang=js"
import style0 from "./RWASection.vue?vue&type=style&index=0&id=2b296a70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b296a70",
  null
  
)

export default component.exports